import * as React from 'react';
import { MdArrowDropDown } from 'react-icons/md';
import { SelectItem } from '../types';
import styles from './option-btn-next-level.scss';

export interface OptionBtnNextLevelProps {
  item: SelectItem;
  onClick: (item: SelectItem) => void;
}

export  const OptionBtnNextLevel = React.memo((props:OptionBtnNextLevelProps) => {
  const onClick = () => {
    props.onClick(props.item);
  };

  return <button className={`btn ${styles.uiNextLevelBtn}`} type="button" onClick={onClick}>
    <MdArrowDropDown className="material-icons ui-rotate-270" />
  </button>;
});
